import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class LogOutDialog {
  private readonly authService = inject(AuthService);
  private readonly dialogRef = inject(MatDialogRef);

  public loading = false;

  onClose(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.authService.logOut();
    this.loading = true;
    setTimeout(() => {
      this.dialogRef.close(true);
    }, 1000);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
